import React from 'react'
import { motion } from 'framer-motion'
import './about.css'
import ME from '../../assets/images/me-about.jpg'
import { BsCodeSlash } from 'react-icons/bs'
import { MdDeveloperMode } from 'react-icons/md'
import { SiCodersrank } from 'react-icons/si'
import { Link } from 'react-router-dom'
import { getStatistics, getAbout } from '../../data/dataLoader'

// ✅ IMPORT EDUCATION
import Education from './Education'

import {
  fadeInUp,
  fadeInLeft,
  fadeInRight,
  staggerContainer,
  staggerItem,
  cardHover,
  iconBounce
} from '../../utils/animations'

const About = () => {
  const statistics = getStatistics()
  const aboutInfo = getAbout()

  const cardData = [
    {
      id: 1,
      icon: <BsCodeSlash className="about__icon" />,
      title: 'Coding',
      count: statistics.coding_questions
    },
    {
      id: 2,
      icon: <MdDeveloperMode className="about__icon" />,
      title: 'Projects',
      count: statistics.projects
    },
    {
      id: 3,
      icon: <SiCodersrank className="about__icon" />,
      title: 'CP',
      count: statistics.contests
    }
  ]

  return (
    <motion.section id="about" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
      <motion.h5 variants={fadeInUp}>Get to Know</motion.h5>
      <motion.h2 variants={fadeInUp}>About Me</motion.h2>

      <div className="container about__container">

        {/* LEFT IMAGE */}
        <motion.div className="about__me" variants={fadeInLeft}>
          <div className="about__me-image">
            <img src={ME} alt="about me" />
          </div>
        </motion.div>

        {/* CARDS */}
        <motion.div className="about__content" variants={fadeInRight}>
          <motion.div className="about__cards" variants={staggerContainer}>
            {cardData.map(card => (
              <motion.article
                className="about__card"
                key={card.id}
                variants={staggerItem}
                whileHover={cardHover.hover}
              >
                <motion.div variants={iconBounce} whileHover="hover">
                  {card.icon}
                </motion.div>
                <h5>{card.title}</h5>
                <small>{card.count}</small>
              </motion.article>
            ))}
          </motion.div>
        </motion.div>

        {/* TEXT */}
        <motion.div className="about__text" variants={fadeInUp}>
          <p>
            {aboutInfo.greeting}
            <br />
            {aboutInfo.education}
            <br />
            {aboutInfo.profession}
            <br />
            {aboutInfo.current_role}
            <br />
            {aboutInfo.passion}
          </p>

          {window.screen.width > 600 ? (
            <Link to="/contact" className="btn btn-primary">
              Let's Talk
            </Link>
          ) : (
            <a href="#contact" className="btn btn-primary">
              Let's Talk
            </a>
          )}
        </motion.div>
      </div>

      {/* ✅ 🔥 EDUCATION SECTION ADDED HERE */}
      <motion.div
        className="education__wrapper"
        variants={fadeInUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        style={{ marginTop: "4rem" }}
      >
        <Education />
      </motion.div>

    </motion.section>
  )
}

export default About